module.exports = __webpack_public_path__ + "7d994297.svg";